import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TypingContextType {
  isTypingComplete: boolean;
  setIsTypingComplete: (complete: boolean) => void;
  currentMessageId: string | null;
  setCurrentMessageId: (id: string | null) => void;
}

const TypingContext = createContext<TypingContextType | undefined>(undefined);

interface TypingProviderProps {
  children: ReactNode;
}

export const TypingProvider: React.FC<TypingProviderProps> = ({ children }) => {
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [currentMessageId, setCurrentMessageId] = useState<string | null>(null);

  const value: TypingContextType = {
    isTypingComplete,
    setIsTypingComplete,
    currentMessageId,
    setCurrentMessageId,
  };

  return (
    <TypingContext.Provider value={value}>
      {children}
    </TypingContext.Provider>
  );
};

export const useTyping = (): TypingContextType => {
  const context = useContext(TypingContext);
  if (context === undefined) {
    throw new Error('useTyping must be used within a TypingProvider');
  }
  return context;
}; 